/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import MDButton from "../../components/MDButton/index";

import Select from "react-select";
import TextError from "utils/TextError";
import MDInput from "../../components/MDInput/index";

import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import CreateButton from "../../components/standardized-components/CreateButton";
import DeleteButton from "../../components/standardized-components/DeleteButton";

import EditButton from "../../components/standardized-components/EditButton";

import {
  createDynamicColumn,
  createNewResourceGroup,
  deleteResourceGroup,
  getDynamicColumn,
  getResourceGroup,
  getSubModulesByRoleId,
  updateResourceGroup,
} from "../../store";

import { getLocationsForResourceGroup } from "store";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
};

const deleteStyle = {
  ...style,
  width: 420,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const ResourceGroupScreen = ({
  getResourceGroup,
  createNewResourceGroup,
  updateResourceGroup,
  deleteResourceGroup,
  resourceGroupState,
  getLocationsForResourceGroup,
  getLocationsForResourceGroupReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "90b82a1a-26ba-4548-8715-ba0a2773cd62";

  let roleId = loginDetails?.data?.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let resourceGroupModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "90b82a1a-26ba-4548-8715-ba0a2773cd62",
  );

  let viewAccess = resourceGroupModule
    ? resourceGroupModule.actionId.includes(
        "3d59cd85-637a-4542-94e1-948b984c98e9",
      )
    : null;

  let createAccess = resourceGroupModule
    ? resourceGroupModule.actionId.includes(
        "d7041648-5f31-4044-a405-e8dcd85230be",
      )
    : null;

  let editAccess = resourceGroupModule
    ? resourceGroupModule.actionId.includes(
        "4f4a84ac-96e1-4708-a3b1-68d61ec29a80",
      )
    : null;

  let deleteAccess = resourceGroupModule
    ? resourceGroupModule.actionId.includes(
        "e2f5415b-f1b2-4507-af37-9a4ea1f63846",
      )
    : null;

  const [state, setState] = useState({
    columns: [
      { Header: "Work Center Code", accessor: "woCode" },
      { Header: "Location", accessor: "locationName" },
      {
        Header: "Action",
        accessor: "action",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const [loading, setLoading] = useState(true);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [workCenterId, setWorkCenterId] = useState("");
  const [woCode, setWoCode] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  const [deleteSuccessMsg, setDeleteSuccessMsg] = useState("");
  const [dataToDelete, setDataToDelete] = useState({});

  useEffect(() => {
    getResourceGroup(jwtToken);
  }, []);

  console.log("errorMsg", errorMsg);

  useEffect(() => {
    const data = resourceGroupState?.resourceGroup?.data || [];
    setLoading(resourceGroupState.loading);

    // console.log("Resource Group Data:", data);

    const temp = data.map((item) => ({
      woCode: item.woCode,
      locationName: item.locationName,
      action: (
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          {editAccess && (
            <EditButton
              tooltip="Edit"
              onClick={() => handleOpenEditModal(item)}
            >
              <Icon>edit</Icon>
            </EditButton>
          )}
          {deleteAccess && (
            <DeleteButton
              tooltip="Delete"
              onClick={() => {
                handleOpenDeleteModal(item);
                setWorkCenterId(item.workCenterId);
                setWoCode(item.woCode);
              }}
            >
              <Icon>delete</Icon>
            </DeleteButton>
          )}
        </MDBox>
      ),
    }));

    viewAccess && setState((prev) => ({ ...prev, rows: temp }));
  }, [resourceGroupState]);

  const [assetTypeSelected, setAssetTypeSelected] = useState("");
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = getLocationsForResourceGroupReducer.locations.data
      ? getLocationsForResourceGroupReducer.locations.data
      : [];
    console.log(data);

    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.locationName,
        value: asset.locationId,
      });
    });

    setAssetTypeOptions(tempAssetTypeOptions);
  }, [getLocationsForResourceGroupReducer]);

  const handleAssetTypeChange = (selectedZone) => {
    setAssetTypeSelected(selectedZone);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [buttonName, setButtonName] = useState("Submit");

  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [isErrorCreateNewAsset, setIsErrorCreateNewAsset] = useState(false);
  const [isSuccessCreateNewAsset, setIsSuccessCreateNewAsset] = useState(false);

  console.log("errorMsgForUpdate", errorMsgForUpdate);

  useEffect(() => {
    if (isErrorCreateNewAsset) {
      setTimeout(() => {
        setIsErrorCreateNewAsset(false);
      }, 3000);
    }
  }, [isErrorCreateNewAsset]);

  useEffect(() => {
    if (isSuccessCreateNewAsset) {
      setTimeout(() => {
        setIsSuccessCreateNewAsset(false);
      }, 3000);
    }
  }, [isSuccessCreateNewAsset]);

  const formikCreate = useFormik({
    initialValues: { resourceGroupCode: "", locationId: "" },
    validationSchema: Yup.object({
      resourceGroupCode: Yup.string().required("Code is required"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true);

      const payload = {
        woCode: values.resourceGroupCode,
        locationId: assetTypeSelected?.value,
      };

      const res = await createNewResourceGroup(payload, jwtToken);
      if (res.status) {
        setIsSuccessCreateNewAsset(true);
        getResourceGroup(jwtToken);
        setTimeout(() => {
          handleCloseCreateModal();

          setButtonName("Submit");
        }, 1000);
      } else {
        setIsErrorCreateNewAsset(true);
        setErrorMsg(res?.data?.data?.msg || "Creation failed");
        setIsSubmitting(false);
        setButtonName("Submit");
      }
    },
  });

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const formikEdit = useFormik({
    initialValues: { resourceGroupCode: "", locationId: "" },
    enableReinitialize: true,
    // validationSchema: Yup.object({
    //   resourceGroupCode: Yup.string().required("Code is required"),
    // }),
    onSubmit: async (values) => {
      const payload = {
        workCenterId: editData?.workCenterId,
        woCode: editData?.woCode,
        locationId: assetTypeSelected?.value,
        userId: userId,
      };
      console.log(payload);
      const res = await updateResourceGroup(payload, jwtToken);
      if (res.status) {
        setButtonName("Submit");

        setIsSuccessForUpdate(true);
        getResourceGroup(jwtToken);
        setTimeout(() => handleCloseEditModal(), 1000);
      } else {
        setErrorMsgForUpdate(res?.data?.data?.msg || "Update failed");
        setIsErrorForUpdate(true);
        setButtonName("Submit");
      }
    },
  });

  const handleOpenCreateModal = () => {
    getLocationsForResourceGroup(jwtToken);
    setOpenCreateModal(true);
    setSuccessMsg("");
    setErrorMsg("");
    formikCreate.resetForm();
  };

  const handleOpenEditModal = (data) => {
    getLocationsForResourceGroup(jwtToken);
    setEditData(data);
    setSuccessMsg("");
    setErrorMsg("");
    setOpenEditModal(true);
    setAssetTypeSelected({
      label: data.locationName,
      value: data.locationId,
    });
  };

  const handleCloseCreateModal = () => {
    setAssetTypeSelected("");
    setOpenCreateModal(false);
    setSuccessMsg("");
    setErrorMsg("");
  };

  const handleCloseEditModal = () => {
    setAssetTypeSelected("");
    setOpenEditModal(false);
    setSuccessMsg("");
    setErrorMsg("");
  };

  const [isDeleting, setIsDeleting] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setDataToDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteErrorMsg("");
    setDeleteSuccessMsg("");
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    const res = await deleteResourceGroup(
      dataToDelete.workCenterId,
      userId,
      dataToDelete.woCode,
      dataToDelete.locationId,
      jwtToken,
    );

    if (res.status) {
      setDeleteSuccessMsg("Deleted successfully!");
      getResourceGroup(jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setIsDeleting(false);
      }, 2000);
    } else {
      setDeleteErrorMsg(res?.data?.data?.msg || "Delete failed");
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getResourceGroup(jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDCard>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
              >
                {createAccess && (
                  <CreateButton
                    tooltip="Create Work Center"
                    onClick={() => {
                      handleOpenCreateModal();
                    }}
                  />
                )}
              </MDBox>

              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted
                  tableSearch
                  entriesPerPage={{ defaultValue: 5, entries: [5, 10, 20] }}
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                />
              )}
            </MDCard>
          </Grid>
        </Grid>
      </MDBox>

      {/* Create Modal */}
      <Modal
        open={openCreateModal}
        onClose={handleCloseCreateModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={style}>
          <MDBox ml={3} mt={-1} display="flex" alignItems="center">
            <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
              Create Work Center
            </MDTypography>
            <Tooltip title="Close">
              <IconButton onClick={handleCloseCreateModal}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </MDBox>
          <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

          <MDBox pt={1} pb={3} px={3}>
            <MDBox
              component="form"
              role="form"
              onSubmit={formikCreate.handleSubmit}
            >
              <MDBox>
                <MDBox mb={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Work Center Code
                  </MDTypography>
                  <MDInput
                    name="resourceGroupCode"
                    fullWidth
                    autoComplete="off"
                    onChange={formikCreate.handleChange}
                    onBlur={formikCreate.handleBlur}
                    value={formikCreate.values.resourceGroupCode}
                    inputProps={{ maxLength: 45 }}
                    error={
                      formikCreate.touched.resourceGroupCode &&
                      Boolean(formikCreate.errors.resourceGroupCode)
                    }
                  />
                  {formikCreate.touched.resourceGroupCode &&
                    formikCreate.errors.resourceGroupCode && (
                      <TextError msg={formikCreate.errors.resourceGroupCode} />
                    )}
                </MDBox>

                <MDBox mb={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Location
                  </MDTypography>
                  <Select
                    isClearable
                    className="select-css"
                    maxMenuHeight={90}
                    placeholder="Select Location"
                    name="locationId"
                    value={assetTypeSelected}
                    options={assetTypeOptions}
                    onChange={(selectedOption) => {
                      handleAssetTypeChange(selectedOption);
                      formikCreate.setFieldValue("locationId", selectedOption);
                    }}
                  />
                  {formikCreate.touched.locationId &&
                    formikCreate.errors.locationId && (
                      <TextError msg={formikCreate.errors.locationId} />
                    )}
                </MDBox>

                <MDBox mt={2}>
                  <Collapse in={isSuccessCreateNewAsset}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessCreateNewAsset(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Work center created successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorCreateNewAsset}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorCreateNewAsset(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {/* Could not create the Asset! */}
                      {errorMsg}
                    </Alert>
                  </Collapse>
                </MDBox>

                <div className="mt-3">
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    fullWidth
                    disabled={
                      !formikCreate.isValid ||
                      !assetTypeSelected ||
                      buttonName === "Please wait..."
                    }
                  >
                    {buttonName}
                  </MDButton>
                </div>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDCard>
      </Modal>

      {/* Edit Modal */}
      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={style}>
          <MDBox ml={3} mt={-1} display="flex" alignItems="center">
            <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
              Edit Work Center
            </MDTypography>
            <MDBox>
              <Tooltip title="Close">
                <IconButton
                  aria-label="close"
                  color="inherit"
                  onClick={handleCloseEditModal}
                  style={{
                    background: "whitesmoke",
                    color: "black",
                    borderRadius: 5,
                    marginLeft: "-55px",
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </MDBox>
          </MDBox>

          <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

          <MDBox pt={1} pb={3} px={3}>
            <MDBox
              component="form"
              role="form"
              onSubmit={formikEdit.handleSubmit}
            >
              <MDBox mb={2}>
                <MDTypography variant="h6" fontWeight="medium">
                  Location
                </MDTypography>
                <Select
                  isClearable
                  className="select-css"
                  maxMenuHeight={90}
                  placeholder="Select Location"
                  name="locationId"
                  value={assetTypeSelected}
                  options={assetTypeOptions}
                  onChange={(selectedOption) => {
                    handleAssetTypeChange(selectedOption);
                    formikEdit.setFieldValue("locationId", selectedOption);
                  }}
                />
                {formikEdit.touched.locationId &&
                  formikEdit.errors.locationId && (
                    <TextError msg={formikEdit.errors.locationId} />
                  )}
              </MDBox>

              {/* Success/Error Alerts */}
              <MDBox>
                <Collapse in={isErrorForUpdate}>
                  <Alert
                    severity="error"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setIsErrorForUpdate(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    {errorMsgForUpdate}
                  </Alert>
                </Collapse>
                <Collapse in={isSuccessForUpdate}>
                  <Alert
                    severity="success"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setIsSuccessForUpdate(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                  >
                    Work center updated successfully
                  </Alert>
                </Collapse>
              </MDBox>

              {/* Submit Button */}
              <MDBox mt={3}>
                <MDButton
                  variant="contained"
                  color="success"
                  fullWidth
                  type="submit"
                  disabled={
                    !assetTypeSelected || buttonName === "Please wait..."
                  }
                >
                  {buttonName}
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDCard>
      </Modal>

      {/* Delete Modal */}
      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={deleteStyle}>
          <MDTypography>
            Are you sure you want to delete this work center?
          </MDTypography>
          <MDBox mt={2}>
            <MDButton
              variant="outlined"
              color="info"
              onClick={handleCloseDeleteModal}
            >
              Cancel
            </MDButton>
            <MDButton
              style={{ marginLeft: "0.5rem" }}
              color="error"
              onClick={confirmDelete}
              disabled={isDeleting}
            >
              {isDeleting ? "Please wait..." : "Delete"}
            </MDButton>
          </MDBox>
          <MDBox mt={2}>
            <Collapse in={!!deleteSuccessMsg}>
              <Alert severity="success">{deleteSuccessMsg}</Alert>
            </Collapse>
            <Collapse in={!!deleteErrorMsg}>
              <Alert severity="error">{deleteErrorMsg}</Alert>
            </Collapse>
          </MDBox>
        </MDCard>
      </Modal>
      <Modal
        open={openCreateColumnReorderModal}
        onClose={handleCloseCreateColumnReorderModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDCard sx={styleForColumnReorder}>
          <MDTypography>Are you sure you want to submit?</MDTypography>
          <MDBox mt={2}>
            <MDButton
              style={{ width: "10rem", marginRight: "0.5rem" }}
              color="info"
              variant="outlined"
              onClick={handleCloseCreateColumnReorderModal}
            >
              Cancel
            </MDButton>
            <MDButton
              style={{ width: "10rem", marginLeft: "0.5rem" }}
              color="success"
              onClick={handleDynamicColumn}
            >
              Submit
            </MDButton>
          </MDBox>
          <MDBox mt={2}>
            <Collapse in={isSuccessColumnReorder}>
              <Alert
                severity="success"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setIsSuccessColumnReorder(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                Data updated successfully!
              </Alert>
            </Collapse>
            <Collapse in={isErrorColumnReorder}>
              <Alert
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setIsErrorColumnReorder(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {isErrorMsgForColumnReorder}
              </Alert>
            </Collapse>
          </MDBox>
        </MDCard>
      </Modal>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => ({
  resourceGroupState: state.getResourceGroupReducer,
  getLocationsForResourceGroupReducer:
    state.getLocationsForResourceGroupReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  getDynamicColumnReducer: state.getDynamicColumnReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getResourceGroup: (jwtToken) => dispatch(getResourceGroup(jwtToken)),
  createNewResourceGroup: (payload, jwtToken) =>
    dispatch(createNewResourceGroup(payload, jwtToken)),
  updateResourceGroup: (payload, jwtToken) =>
    dispatch(updateResourceGroup(payload, jwtToken)),
  deleteResourceGroup: (id, userId, woCode, locationId, jwtToken) =>
    dispatch(deleteResourceGroup(id, userId, woCode, locationId, jwtToken)),
  getLocationsForResourceGroup: (jwtToken) =>
    dispatch(getLocationsForResourceGroup(jwtToken)),
  getDynamicColumn: (userId, subModuleId, jwtToken) =>
    dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
  createDynamicColumn: (payload, jwtToken) =>
    dispatch(createDynamicColumn(payload, jwtToken)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResourceGroupScreen);
